import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobTypeLookupComponent } from './job-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [JobTypeLookupComponent],
  exports: [JobTypeLookupComponent],
  providers: []
})
export class JobTypeLookupModule { }
